import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import {
  Button,
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  Input,
  FormField,
} from '@/shared/components/ui';
import { useCreateAudienceEntry } from '../hooks';
import type { AudienceIdentifierType } from '@troia-v3/types';

export interface AddEntryModalProps {
  isOpen: boolean;
  onClose: () => void;
  audienceId: string;
  identifierType: AudienceIdentifierType;
}

export const AddEntryModal: React.FC<AddEntryModalProps> = ({
  isOpen,
  onClose,
  audienceId,
  identifierType,
}) => {
  const createEntry = useCreateAudienceEntry(audienceId);
  const [identifier, setIdentifier] = useState('');
  const [name, setName] = useState('');

  useEffect(() => {
    if (isOpen) {
      setIdentifier('');
      setName('');
    }
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!identifier.trim()) return;
    try {
      await createEntry.mutateAsync({
        identifier: identifier.trim(),
        name: name.trim() || undefined,
      });
      toast.success('Entrada adicionada');
      onClose();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Erro ao adicionar entrada');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="md">
      {/* F74: título 18px via prop tipada do header */}
      <ModalHeader title="Adicionar entrada" onClose={onClose} />
      <ModalContent>
        <div className="space-y-4">
          <FormField label={identifierType === 'email' ? 'Email' : 'Telefone'} required>
            <Input
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder={identifierType === 'email' ? 'exemplo@dominio.com' : '5511999999999'}
              required
            />
          </FormField>
          <FormField label="Nome (opcional)">
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Nome do destinatário"
            />
          </FormField>
        </div>
      </ModalContent>
      <ModalFooter>
        {/* F71: Cancelar = Button secondary (bordado) em todo footer de modal */}
        <Button
          type="button"
          variant="secondary"
          onClick={onClose}
          data-testid="add-entry-cancel"
        >
          Cancelar
        </Button>
        <Button
          type="button"
          variant="primary"
          onClick={handleSubmit}
          disabled={!identifier.trim()}
          loading={createEntry.isPending}
          data-testid="add-entry-submit"
        >
          {createEntry.isPending ? 'Adicionando...' : 'Adicionar'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
